import { BaseShareActionArgs, buildShareButtonComponent } from './base'
import { WhatsappIcon } from '../../assets/icons'
import { encodeShareURL, isMobileOrTablet } from '../../helpers/sharing_helper'

export const whatsappShareAction = ({ shareUrl, utmParams }: BaseShareActionArgs) =>
  window.open(
    `https://${isMobileOrTablet() ? 'api' : 'web'}.whatsapp.com/send?text=${encodeShareURL(shareUrl, utmParams)}`
  )

export const WhatsappButton = buildShareButtonComponent({
  action: whatsappShareAction,
  ariaLabel: 'WhatsApp',
  className: 'share-button--whatsapp',
  icon: WhatsappIcon,
})

export type WhatsappButtonProps = Parameters<typeof WhatsappButton>['0']
